import { render } from "./GroupPermissionManagement.vue?vue&type=template&id=0a444db6&scoped=true"
import script from "./GroupPermissionManagement.vue?vue&type=script&lang=js"
export * from "./GroupPermissionManagement.vue?vue&type=script&lang=js"

import "./GroupPermissionManagement.vue?vue&type=style&index=0&id=0a444db6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a444db6"]])

export default __exports__